import FontInput from '../../../../components/FontInput/FontInput'
import TextInput from '../../../../components/TextInput/TextInput'
import TextOptions from '../../../../components/TextOptions/TextOptions'
import LetterSpacingInput from '../../../../components/LetterSpacingInput/LetterSpacingInput'
import { useRef } from 'react'
import ColorInput from '../../../../components/ColorInput/ColorInput'
import Dropdown from '../../../../components/Dropdown/Dropdown'

const PlaylistEditModalWaveformTab = ({
  values,
  setValue,
  onSaveClick,
  onSavePublishClick,
  publishLabel,
}) => {
  const ref = useRef()

  return (
    <div className="p-6" ref={ref}>
      <h3 className="mb-4">Waveform Settings</h3>
      <h4 className="mb-2">Waveform</h4>

      <div className="mt-4 ">
        <Dropdown
          label="Waveform"
          options={[
            { id: 0, name: 'Hidden' },
            { id: 1, name: 'Visible' },
          ]}
          value={values.showWaveform}
          onChange={(val) => setValue('showWaveform', parseInt(val, 10))}
        ></Dropdown>
      </div>
      <div className="mt-4 ">
        <Dropdown
          label="Play, Previous and Next Buttons"
          options={[
            { id: 0, name: 'Hidden' },
            { id: 1, name: 'Visible' },
          ]}
          value={values.showPlayControls}
          onChange={(val) => setValue('showPlayControls', parseInt(val, 10))}
        ></Dropdown>
      </div>
      {values.showWaveform ? (
        <div>
          <h4 className="mb-4 mt-6">Override Track Themes</h4>
          <p>
            These new colors will take the place of all track colors on the
            playlist unless those tracks also have overrides.
          </p>

          <div className="mt-4">
            <ColorInput
              label="Primary Color"
              value={values.highlightColor}
              containerRef={ref}
              onChange={(value) => setValue('highlightColor', value)}
            />
          </div>
          <div className="mt-4">
            <ColorInput
              label="Mouse Over Color"
              value={values.fgColor}
              containerRef={ref}
              onChange={(value) => setValue('fgColor', value)}
            />
          </div>
          <div className="mt-4">
            <ColorInput
              label="Background Color"
              value={values.bgColor}
              containerRef={ref}
              onChange={(value) => setValue('bgColor', value)}
            />
          </div>
        </div>
      ) : null}
      <h4 className="mb-4 mt-8">Controls</h4>

      <div className="mt-4 ">
        <Dropdown
          label="Volume, Loop and Metadata Buttons"
          options={[
            { id: 0, name: 'Hidden' },
            { id: 1, name: 'Visible' },
          ]}
          value={values.showTrackInformation}
          onChange={(val) =>
            setValue('showTrackInformation', parseInt(val, 10))
          }
        ></Dropdown>
      </div>

      <div className="mt-4">
        <TextOptions
          label="Currently Playing"
          values={values.currentlyPlayingText}
          onChange={(value) => setValue('currentlyPlayingText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4">
        <TextOptions
          label="Progress and Duration"
          values={values.durationText}
          onChange={(value) => setValue('durationText', value)}
          containerRef={ref}
        />
      </div>

      <div className="mt-10 mb-4">
        <button
          className="button bg-pink hover:bg-pink-off"
          onClick={onSaveClick}
        >
          Save
        </button>
        <button
          className="button ml-4 text-white-dark"
          onClick={onSavePublishClick}
        >
          {publishLabel}
        </button>
      </div>
    </div>
  )
}

export default PlaylistEditModalWaveformTab
